import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Label,
    Spinner,
    Progress,
    Table, Input
} from "reactstrap"
import { accessRole } from '../../../../helpers/access_role'
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import YearSelect from '../../../../helpers/ui/YearSelect'
import Select from '../../../../helpers/ui/CustomSelect'
import { Preview, FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvField, AvGroup, AvCheckboxGroup, AvCheckbox, AvInput } from "availity-reactstrap-validation"

import { Redirect, Link } from "react-router-dom"

import Shimmer from 'react-shimmer-effect'

import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/kepegawaian/menuService'

import ApproveBloc from '../ApprovePenghargaan/Blocs/ApproveBloc'

class DetailView extends Component {

    source
    defaultSize = 10
    approveBloc = new ApproveBloc();
    timer

    constructor(props) {
        super(props)
        this.state = {
            detail: {},
            typeOption: [],
            employeeOption: [],
            awardFilter: {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: 'type_of_award_name',
                        order: 'asc' 
                    }
                },
            employeeFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'employee_id',
                    order: 'asc' 
                }
            }
        }
    }

    loadAwardType = async () => {
        let offset = (this.state.awardFilter.page_number-1)*this.state.awardFilter.page_size
        const query = {
            search: this.state.awardFilter.filter_value,
            limit: this.state.awardFilter.page_size,
            offset: offset,
            order: this.state.awardFilter.sort_order.column,
            sort: this.state.awardFilter.sort_order.order,
            status: 1
        }
        await this.approveBloc.fetchType(query, this.source.token)
    }

    loadEmployee  = async () => {
        let offset = (this.state.employeeFilter.page_number-1)*this.state.employeeFilter.page_size
        const query = {
            search: this.state.employeeFilter.filter_value,
            limit: this.state.employeeFilter.page_size,
            offset: offset,
            order: this.state.employeeFilter.sort_order.column,
            sort: this.state.employeeFilter.sort_order.order,
            status: 1
        }
        await this.approveBloc.fetchEmployeeList(query, this.source.token)
    }

    loadDetail = async () => {
        const query = {
            uuid: this.props.award_uuid,
            employee_uuid: this.props.employee_uuid,
            recomendation_uuid: this.props.recomendation_uuid
        }
        await this.approveBloc.fetchDetail(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadAwardType()
        this.loadEmployee()
        this.loadDetail()
    }

    componentDidMount() {
        this.setTokenAPI()

        this.approveBloc.approveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.approveBloc.typeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ typeOption: result.data.response.result })    
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.approveBloc.employeeListChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ employeeOption: result.data.response.result })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.approveBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response })
                    break;
                default:
                    break;
            }
        })

    }


    render() {
        const { detail, typeOption } = this.state
        let awardType = typeOption.filter(opt => opt.type_of_award_uuid === detail?.award_type_of_award_uuid)[0]?.type_of_award_name
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                <Link to={`/kepegawaian/pemberian_penghargaan.html?approve&uuid=${this.props.uuid}`}>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                            </div>
                            <CardTitle>Rekomendasi Penghargaan</CardTitle>
                            <hr />
                            <AvForm
                                className="needs-validation"
                                onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                            >
                                <Row className="mb-3">
                                    <Label className="col-md-2 col-form-label">
                                        Pegawai 
                                    </Label>
                                    <Col md="4">
                                        { Object.keys(detail).length ? 
                                            <Label className="col-form-label">
                                                {detail?.employee?.employee_full_name + ' - ' + detail?.employee?.employee_current_position_name}
                                            </Label>
                                            :
                                            <Shimmer>
                                                <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                            marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                            </Shimmer>
                                        }
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Label className="col-md-2 col-form-label">
                                        Jenis Penghargaan
                                    </Label>
                                    <Col md="3">
                                        { Object.keys(detail).length ? 
                                            <Label className="col-form-label">
                                                {awardType}
                                            </Label>
                                            :
                                            <Shimmer>
                                                <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                            marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                            </Shimmer>
                                        }
                                    </Col>
                                </Row>

                                { detail?.award_approval_status == 1 &&
                                    <Fragment>
                                        <Row className="mb-3">
                                            <Label className="col-md-2 col-form-label">
                                                No Kepres
                                            </Label>
                                            <Col md="3">
                                                { Object.keys(detail).length ? 
                                                    <Label className="col-form-label">
                                                        {detail?.award_decree_number}
                                                    </Label>
                                                    :
                                                    <Shimmer>
                                                        <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                                    marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                                    </Shimmer>
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label className="col-md-2 col-form-label">
                                                Tanggal Kepres
                                            </Label>
                                            <Col md="2">
                                                { Object.keys(detail).length ? 
                                                    <Label className="col-form-label">
                                                        {detail?.award_decree_date}
                                                    </Label>
                                                    :
                                                    <Shimmer>
                                                        <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                                    marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                                    </Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                    </Fragment>
                                }

                                <Row className="mb-3">
                                    <Label className="col-md-2 col-form-label">
                                        Pejabat Penetap
                                    </Label>
                                    <Col md="4">
                                        { Object.keys(detail).length ? 
                                            <Label className="col-form-label">
                                                {detail?.award_signatories_official}
                                            </Label>
                                            :
                                            <Shimmer>
                                                <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                            marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                            </Shimmer>
                                        }
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Label className="col-md-2 col-form-label">
                                        Dokumen Pendukung
                                    </Label>
                                    <Col md="4">
                                        { Object.keys(detail).length ? 
                                            <Label className="col-form-label">
                                                <Preview 
                                                    col="5"
                                                    value={detail?.document}
                                                />
                                            </Label>
                                            :
                                            <Shimmer>
                                                <div style={{ width: "180px", height: "200px", alignSelf: "center", borderRadius: "8px", 
                                                            marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                            </Shimmer>
                                        }
                                    </Col>
                                </Row>
                            </AvForm>
                        </CardBody>
                    </Card>
                </Container>
            </Fragment>
        )
    }
}

export default DetailView;